export { default as BoletaTraslado } from "./BoletaTraslado";
